
define('lazyloader',['underscore'], function(_) {
    
    // var loader = new LazyLoader('views');
    // 
    // loader.get('main').then( function(View) {
    //     console.log('LOADED', View);
    // });
    
    var LazyLoader = function(prefix, suffix) {
        this.prefix = prefix; // string or array
        this.suffix = suffix; // string or array
        this.loading = [];
        this.loaded = [];
    };
    
    _.extend(LazyLoader.prototype, {
        
        get: function() {
            var modules = _.flatten(Array.prototype.slice.call(arguments));
            var modulePath = this.modulePath.bind(this);
            var dfd = $.Deferred();
            var loader = this;
            
            var fileNames = _.map(modules, this.modulePath.bind(this));
            var requiredModules = _.difference(fileNames, this.loading);
            
            require(requiredModules, function() {
                loader.loading = _.difference(loader.loading, requiredModules);
                loader.loaded = loader.loaded.concat(_.difference(modules, loader.loaded));
                require(fileNames, function() {
                    dfd.resolve.apply(dfd, arguments);
                });
            });
            
            return dfd.promise();
        },
        
        has: function(module) {
            var modules = _.flatten(arguments);
            return _.intersection(modules, this.loaded).length > 0;
        },
        
        modulePath: function(module) {
            var segments = [].concat(this.prefix).concat(module).concat(this.suffix);
            return _.compact(segments).join('/');
        }
        
    });
    
    return LazyLoader;
    
});